module.exports = __webpack_public_path__ + "static/media/lp_experience.5a9485f4.png";